/** The display mode of "My Tasks" (calendar / list), remembered per device like the other view
 *  preferences. The URL wins; unavailable storage just means "the default". */
export type MyTasksView = 'calendar' | 'list';

const KEY = 'zadok.myTasks.view';

export function parseView(value: string | null): MyTasksView | null {
  return value === 'calendar' || value === 'list' ? value : null;
}

export function readStoredView(): MyTasksView | null {
  try {
    return parseView(window.localStorage.getItem(KEY));
  } catch {
    return null;
  }
}

export function storeView(view: MyTasksView): void {
  try {
    window.localStorage.setItem(KEY, view);
  } catch {
    // The choice just is not remembered.
  }
}
